/** Must match CREDesktopAgent.exe discovery contract and extension config. */
export const AGENT_PORT_START = 47890;
export const AGENT_PORT_COUNT = 10;
export const AGENT_SIGNATURE = "CREDesktopAgent";
export const AGENT_PROBE_MS = 800;
/** Min gap between duplicate in-flight connect attempts. */
export const AGENT_CONNECT_RETRY_COOLDOWN_MS = 1500;
/** Back off full port scans after failure (no agent / CORS block). */
export const AGENT_CONNECT_BACKOFF_INITIAL_MS = 60_000;
export const AGENT_CONNECT_BACKOFF_MAX_MS = 300_000;

const INSERT_METHODS = ["WM_SETTEXT", "WM_COPYDATA"];
const PASTE_METHODS = ["Clipboard", "SendMessage"];

/** Defaults sent on SaveMySettings (matches MedMic extension). */
export const DEFAULT_INSERT_METHOD = INSERT_METHODS[0];
export const DEFAULT_PASTE_METHOD = PASTE_METHODS[0];

export const COMPANION_APP_LABEL = "MedMic companion";

export const AGENT_DOWNLOAD_URL =
  "https://prod-cre-apim.azure-api.net/CreReportingMicroservice/agent-download";

export function getAgentDownloadUrl() {
  return AGENT_DOWNLOAD_URL;
}
